import React from 'react';
import classNames from 'classnames';
import styles from './ListItem.css';

export interface ListItemProps {
  /** Adds additional classes to the component */
  className?: string;
  /** List Item Contents */
  children: JSX.Element[] | JSX.Element;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Renders the children passed to it in a Grid with column layout as default
 *
 * @param {ListItemProps} props
 *
 * @returns JSX.Element
 */
export const ListItem = ({ children, className, 'data-testid': dataTestId }: ListItemProps) => (
  <div
    className={classNames(styles.defaultLayout, className, styles.list)}
    data-testid={dataTestId}
  >
    {children}
  </div>
);

export default ListItem;
